function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

import { FetchResponse } from './fetch_response';
import { RequestInterceptor } from './request_interceptor';
import { getCookie, compact, metaContent, stringEntriesFromFormData, mergeEntries } from './lib/utils';
export var FetchRequest = /*#__PURE__*/function () {
  function FetchRequest(method, url) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, FetchRequest);

    this.method = method;
    this.options = options;
    this.originalUrl = url.toString();
  }

  _createClass(FetchRequest, [{
    key: "perform",
    value: function () {
      var _perform = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var requestInterceptor, fetch, response, responseStatusIsTurboStreamable;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                requestInterceptor = RequestInterceptor.get();

                if (!requestInterceptor) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return requestInterceptor(this);

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 10:
                fetch = this.responseKind === 'turbo-stream' && window.Turbo ? window.Turbo.fetch : window.fetch;
                _context.t1 = FetchResponse;
                _context.next = 14;
                return fetch(this.url, this.fetchOptions);

              case 14:
                _context.t2 = _context.sent;
                response = new _context.t1(_context.t2);

                if (!(response.unauthenticated && response.authenticationURL)) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return", Promise.reject(window.location.href = response.authenticationURL));

              case 18:
                if (!response.isScript) {
                  _context.next = 21;
                  break;
                }

                _context.next = 21;
                return response.activeScript();

              case 21:
                responseStatusIsTurboStreamable = response.ok || response.unprocessableEntity;

                if (!(responseStatusIsTurboStreamable && response.isTurboStream)) {
                  _context.next = 25;
                  break;
                }

                _context.next = 25;
                return response.renderTurboStream();

              case 25:
                return _context.abrupt("return", response);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function perform() {
        return _perform.apply(this, arguments);
      }

      return perform;
    }()
  }, {
    key: "addHeader",
    value: function addHeader(key, value) {
      var headers = this.additionalHeaders;
      headers[key] = value;
      this.options.headers = headers;
    }
  }, {
    key: "sameHostname",
    value: function sameHostname() {
      if (!this.originalUrl.startsWith('http:') && !this.originalUrl.startsWith('https:')) {
        return true;
      }

      try {
        return new URL(this.originalUrl).hostname === window.location.hostname;
      } catch (_) {
        return true;
      }
    }
  }, {
    key: "fetchOptions",
    get: function get() {
      return {
        method: this.method.toUpperCase(),
        headers: this.headers,
        body: this.formattedBody,
        signal: this.signal,
        credentials: this.credentials,
        redirect: this.redirect,
        keepalive: this.keepalive
      };
    }
  }, {
    key: "headers",
    get: function get() {
      var baseHeaders = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': this.contentType,
        Accept: this.accept
      };

      if (this.sameHostname()) {
        baseHeaders['X-CSRF-Token'] = this.csrfToken;
      }

      return compact(Object.assign(baseHeaders, this.additionalHeaders));
    }
  }, {
    key: "csrfToken",
    get: function get() {
      return getCookie(metaContent('csrf-param')) || metaContent('csrf-token');
    }
  }, {
    key: "contentType",
    get: function get() {
      if (this.options.contentType) {
        return this.options.contentType;
      } else if (this.body == null || this.body instanceof window.FormData) {
        return undefined;
      } else if (this.body instanceof window.File) {
        return this.body.type;
      }

      return 'application/json';
    }
  }, {
    key: "accept",
    get: function get() {
      switch (this.responseKind) {
        case 'html':
          return 'text/html, application/xhtml+xml';

        case 'turbo-stream':
          return 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml';

        case 'json':
          return 'application/json, application/vnd.api+json';

        case 'script':
          return 'text/javascript, application/javascript';

        default:
          return '*/*';
      }
    }
  }, {
    key: "body",
    get: function get() {
      return this.options.body;
    }
  }, {
    key: "query",
    get: function get() {
      var originalQuery = (this.originalUrl.split('?')[1] || '').split('#')[0];
      var params = new URLSearchParams(originalQuery);
      var requestQuery = this.options.query;

      if (requestQuery instanceof window.FormData) {
        requestQuery = stringEntriesFromFormData(requestQuery);
      } else if (requestQuery instanceof window.URLSearchParams) {
        requestQuery = requestQuery.entries();
      } else {
        requestQuery = Object.entries(requestQuery || {});
      }

      mergeEntries(params, requestQuery);
      var query = params.toString();
      return query.length > 0 ? "?".concat(query) : '';
    }
  }, {
    key: "url",
    get: function get() {
      return this.originalUrl.split('?')[0].split('#')[0] + this.query;
    }
  }, {
    key: "responseKind",
    get: function get() {
      return this.options.responseKind || 'html';
    }
  }, {
    key: "signal",
    get: function get() {
      return this.options.signal;
    }
  }, {
    key: "redirect",
    get: function get() {
      return this.options.redirect || 'follow';
    }
  }, {
    key: "credentials",
    get: function get() {
      return this.options.credentials || 'same-origin';
    }
  }, {
    key: "keepalive",
    get: function get() {
      return this.options.keepalive || false;
    }
  }, {
    key: "additionalHeaders",
    get: function get() {
      return this.options.headers || {};
    }
  }, {
    key: "formattedBody",
    get: function get() {
      var bodyIsAString = Object.prototype.toString.call(this.body) === '[object String]';
      var contentTypeIsJson = this.headers['Content-Type'] === 'application/json';

      if (contentTypeIsJson && !bodyIsAString) {
        return JSON.stringify(this.body);
      }

      return this.body;
    }
  }]);

  return FetchRequest;
}();